import { ApiFieldError } from 'src/types';
import actionCreatorFactory from 'typescript-fsa';

export const actionCreator = actionCreatorFactory(`@manager/features/loanapp_roles`);
export type APIError = ApiFieldError;
export type UpdateLoanAppRoleParams = any;

export const describeLoanAppRoleActions = actionCreator.async<
  any,
  any,
  APIError[]
>('request-borrower');

export const updateLoanAppRoleActions = actionCreator.async<
  UpdateLoanAppRoleParams,
  any,
  APIError[]
>(`update`);
